module.exports = __webpack_public_path__ + "static/media/icn-search.2515a39c.svg";